module.exports = __webpack_public_path__ + "img/mavatar.c9730d84.png";